import { render, staticRenderFns } from "./TableWithBigListOptions.vue?vue&type=template&id=28a56b40&"
import script from "./TableWithBigListOptions.vue?vue&type=script&lang=js&"
export * from "./TableWithBigListOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports